export const headingOfCard = ['List1', 'List2', 'List3', 'List1', 'List2'];

export const valuesForLists = [
  {
    id: 'list-1',
    title: 'List1',
    items: [
      { id: 'item-1', content: 'Item 1' },
      { id: 'item-2', content: 'Item 2' },
      { id: 'item-3', content: 'Item 3' },
    ],
  },
  {
    id: 'list-2',
    title: 'List2',
    items: [
      { id: 'item-11', content: 'Item 11' },
      { id: 'item-12', content: 'Item 12' },
    ],
  },
  {
    id: 'list-3',
    title: 'List3',
    items: [
      { id: 'item-11', content: 'Item 15' },
      { id: 'item-12', content: 'Item 16' },
    ],
  },
];

export const managersNames = [
  { label: 'vishal', value: 1 },
  { label: 'vivek', value: 2 },
  { label: 'raman', value: 3 },
  { label: 'manoj', value: 4 },
];

export const colorData = [
  { name: '', color: '#4BCE97' },
  { name: '', color: '#F5CD97' },
  { name: '', color: '#FEA362' },
  { name: '', color: '#F87168' },
  { name: '', color: '#9F8FEF' },
  { name: '', color: '#579DFF' },
];

export const taskMembers = [
  {
    id: '1',
    name: 'Vivek Batra',
  },
  {
    id: '2',
    name: 'Vishal',
  },
  {
    id: '3',
    name: 'Parul Kumar',
  },
  {
    id: '4',
    name: 'Pooja',
  },
  {
    id: '5',
    name: 'Ravi Kumar',
  },
];
export const boardDetail = [
  { ownerName: 'Vishal Verma', ownerType: 'Workspace Owner' },
  { ownerName: 'Raman Gupta', ownerType: 'Admin' },
  { ownerName: 'Vivek Batra', ownerType: 'Admin' },
];

export const descriptionData = {
  description:
    'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Debitis laudantium velit corrupti tenetur magnam dignissimos, numquam corporis adipisci modi, voluptates consectetur mollitia quasi iste alias neque fugit dolore illo odio',
};
export const permissionsData = [
  { title: 'Background Color', description: 'Any member can change the background color' },
  {
    title: 'Edit Workspace',
    description: 'Any workspace member can edit and join the workspace ',
  },
  { title: 'Commenting', description: 'Any member can comment on tickets' },
];
